<template>
  <Transition name="slide-up">
    <footer v-if="chair" id="contact">
      <div
        class="bg-(--main-color) py-10 lg:py-17.5 h-pad text-white grid gap-12.5 lg:grid-cols-2 lg:gap-20 xl:gap-40"
      >
        <div>
          <h2 class="font-semibold mb-5">{{ chair.name }}</h2>
          <div class="xl:grid xl:grid-cols-2">
            <AddressLink :address="chair.address" class="text-white/90" />
            <div class="mt-5 xl:mt-0 transition-[margin]">
              <a
                v-if="chair.contact.phone"
                :href="phoneLink"
                target="_blank"
                class="block mb-1 text-white/90 hover:text-(--accent-color) transition-[color]"
                >{{ chair.contact.phone }}</a
              >
              <a
                v-if="chair.contact.email"
                :href="`mailto:${chair.contact.email}`"
                target="_blank"
                class="block underline text-white/90 hover:text-(--accent-color) transition-[color]"
                >{{ chair.contact.email }}</a
              >
              <SocialMedia :socials="chair.socials" />
            </div>
          </div>
        </div>
        <div>
          <div v-if="chair.partners?.length" class="grid gap-6 grid-cols-[1fr_2px_1fr_2px_1fr]">
            <template v-for="(partner, partnerIndex) in chair.partners" :key="partner.flexKey">
              <div v-if="partnerIndex > 0" class="w-[1px] h-full bg-white" />
              <PartnerCard :partner="partner" />
            </template>
          </div>
          <p v-if="chair.description" class="text-sm mt-5">{{ chair.description }}</p>
        </div>
      </div>
      <div
        class="h-pad py-2.5 text-white/80 bg-main-dark lg:px-5 text-sm flex flex-col gap-1 lg:flex-row justify-between"
      >
        <p>
          <span class="mr-1">{{ credits }}</span>
          <LangRouterLink
            :to="{ name: $routes.POLICIES }"
            class="inline-block underline hover:no-underline"
          >
            {{ $t("policies.title") }}
          </LangRouterLink>
        </p>
        <RawHtml
          tag="a"
          href="https://boitebeet.com"
          target="_blank"
          :html="$t('designed_developed_by')"
        />
      </div>
    </footer>
  </Transition>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { PartnerCard } from "@/components/cards";
import { RawHtml } from "@/components/helpers";
import { AddressLink, SocialMedia } from "@/components/small";
import LangRouterLink from "@/components/helpers/LangRouterLink.vue";

export default {
  name: "SiteFooter",
  props: {
    chair: {
      type: [Object, null] as PropType<Chair | null>,
      required: true,
    },
  },
  components: {
    LangRouterLink,
    PartnerCard,
    AddressLink,
    RawHtml,
    SocialMedia,
  },
  computed: {
    credits() {
      return this.$t("credits")
        .replace(":YEAR", new Date().getFullYear().toString())
        .replace(":NAME", this.chair?.name || "");
    },
    phoneLink() {
      if (!this.chair?.contact?.phone) return undefined;

      return `tel:+${this.chair.contact.phone.replace(/[^0-9]+/g, "")}`;
    },
  },
};
</script>
